import { VirtualListRef } from '@prio365/prio365-react-library';
import { useCallback, useEffect, useMemo, useRef } from 'react';

export const useContactListActiveItem = <T, U extends VirtualListRef<T>>(
  searchTerm: string,
  contactList: T[],
  getId: (value: T) => string,
  dontSetActiveIndex: boolean | undefined = false
) => {
  const ref = useRef<U>(null);

  const setRef = useCallback((value: U) => {
    ref.current = value;
  }, []);

  useEffect(() => {
    if (!dontSetActiveIndex && ref.current) {
      if (contactList.length === 0 || !contactList) return;
      const pathSegments = window.location.pathname.split('/');
      const uuidRegex =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
      const activeContactId =
        [...pathSegments]
          .reverse()
          .find((segment) => uuidRegex.test(segment)) || null;
      if (activeContactId) {
        const listActiveContactId = getId(
          contactList[ref.current.getActiveIndex()]
        );
        if (listActiveContactId !== activeContactId) {
          ref.current.setActiveIndex(
            contactList.findIndex((item) => getId(item) === activeContactId)
          );
        }
      }
    }
  }, [dontSetActiveIndex, ref, searchTerm, contactList, getId]);

  return useMemo(() => {
    return {
      setRef,
    };
  }, [setRef]);
};
